import { MessageNotification } from "services/types/notifications";
import Typography from "@mui/material/Typography";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";
import { NavLink as NavLinkBase } from "react-router-dom";
import { misc } from "app/themes/colors";
import { styled } from "@mui/material/styles";

const NavLink = styled(NavLinkBase)(({ theme }) => ({
  "&": {
    color: misc.blackAsphalt,
    fontSize: 14,
    fontWeight: 700,
    mb: 0.5,
  },
  "&:hover": {
    cursor: "pointer",
    color: misc.linkColor,
  },

  "&.active": {},
}));

const MessageNotificationComponent = ({
  title,
  description,
  extra,
}: MessageNotification) => {
  return (
    <ListItemText
      primary={
        <NavLink
          to={`/inbox/${extra?.patient_id || ""}`}
          style={{ display: "flex", flex: 1 }}
        >
          {title}
        </NavLink>
      }
      secondary={<Typography variant="body1">{description}</Typography>}
    />
  );
};

export default MessageNotificationComponent;
